import { Button, Typography, useTheme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InfoBox } from './InfoBox';
import { AllNoneButtons } from './shared/AllNoneButtons';

interface LevelFilterProps {
  allLevels: number[];
  activeLevels: Set<number>;
  onToggleLevel: (level: number) => void;
  onSelectAll: () => void;
  onClearAll: () => void;
}

export const LevelFilter: React.FC<LevelFilterProps> = ({
  allLevels,
  activeLevels,
  onToggleLevel,
  onSelectAll,
  onClearAll
}) => {
  const theme = useTheme();
  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.level_filter.title')} style={{ marginBottom: '15px' }}>
      <Typography component="p" variant="body2" style={{ margin: '0 0 8px 0' }}><strong>{translate('osfc.storage_ui.level_filter.show_levels')}</strong></Typography>
      <div style={{ margin: '10px 0', display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        {allLevels.map(level => (
          <Button
            key={level}
            onClick={() => onToggleLevel(level)}
            variant={activeLevels.has(level) ? 'contained' : 'outlined'}
            color="secondary"
            size="small"
            style={{ minWidth: '36px', padding: '5px' }}
          >
            {level}
          </Button>
        ))}
      </div>
      <AllNoneButtons onSelectAll={onSelectAll} onClearAll={onClearAll} />
    </InfoBox>
  );
};
